import React, { useState, useRef, useEffect } from "react";
import { SHOW_AI_FEATURES } from "../../../../../../env";

const questionMarkSvg = (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="#9ca3af" strokeWidth="2" />
        <path d="M12 16v-4m0-4h.01" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export default function HeaderActions({
    tab,
    company,
    localModule,
    isDataRepository,
    onAccurateFileName,
    onAccurateFolderName,
    onClickFileReportHistory,
    onClickViewUnallocatedFiles,
    checkDuplicatedFiles,
    onClickDeduperReportHistory,
    onAutoFill,
    onDiagnose,
}) {
    const [diagnoseOpen, setDiagnoseOpen] = useState(false);
    const [diagnoseSelection, setDiagnoseSelection] = useState(new Set(['clarence', 'human']));
    const diagnoseRef = useRef(null);

    useEffect(() => {
        const handleMouseDown = (e) => { if (diagnoseRef.current && !diagnoseRef.current.contains(e.target)) setDiagnoseOpen(false); };
        document.addEventListener('mousedown', handleMouseDown);
        return () => document.removeEventListener('mousedown', handleMouseDown);
    }, []);

    const toggleDiagnoseSelection = (key) => {
        setDiagnoseSelection(prev => { const next = new Set(prev); next.has(key) ? next.delete(key) : next.add(key); return next; });
    };

    if (tab === "kitemark") {
        return (
            <>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Audit</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Report</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Digital Certificate</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Full Report</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Report by Section</span>
            </>
        );
    }

    if (!localModule) return null;

    const dropdown = (
        <div className="menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc" style={{ minWidth: '260px' }}>
            {onAutoFill && (
                <p onClick={onAutoFill} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                    <div className="df aic">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_fa_af)">
                                <path d="M3.52723 2.82108L4.74129 3.48554C4.89715 3.5703 4.95458 3.76444 4.86981 3.9203C4.83973 3.97499 4.79598 4.01874 4.74129 4.04882L3.52723 4.71054C3.47254 4.74061 3.42879 4.78436 3.39872 4.83905L2.73426 6.05311C2.6495 6.20897 2.45536 6.2664 2.2995 6.18163C2.24481 6.15155 2.20106 6.1078 2.17098 6.05311L1.50926 4.83905C1.47919 4.78436 1.43544 4.74061 1.38075 4.71054L0.166686 4.04882C0.0108263 3.96405 -0.0465956 3.76991 0.03817 3.61405C0.0682482 3.55936 0.111998 3.51561 0.166686 3.48554L1.38075 2.82108C1.43544 2.791 1.47919 2.74725 1.50926 2.69257L2.17372 1.48124C2.25848 1.32538 2.45536 1.26796 2.61122 1.35546C2.66317 1.38554 2.70692 1.42929 2.737 1.48124L3.40145 2.69257C3.42879 2.74725 3.47254 2.791 3.52723 2.82108Z" fill="#4A67FF" />
                                <path d="M13.6881 1.79629L12.5643 0.672464C12.1487 0.256839 11.4733 0.254105 11.0549 0.66973L1.03345 10.6939C0.617823 11.1096 0.615089 11.785 1.03345 12.2033L2.15728 13.3272C2.5729 13.7428 3.24829 13.7455 3.66665 13.3272L13.6881 3.30567C14.1038 2.89004 14.1038 2.21465 13.6881 1.79629Z" fill="#4A67FF" />
                            </g>
                            <defs><clipPath id="clip0_fa_af"><rect width="14" height="14" fill="white" /></clipPath></defs>
                        </svg>
                        <span className="c3 ml0-5rem">Auto Fill<span className="fs10px c12 ml0-5rem">All Questions</span></span>
                    </div>
                    {questionMarkSvg}
                </p>
            )}
            <p onClick={onAccurateFileName} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb" style={!onAutoFill ? { borderTopLeftRadius: '10px', borderTopRightRadius: '10px' } : {}}>Import Files {questionMarkSvg}</p>
            <p onClick={onAccurateFolderName} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb">Import Folders {questionMarkSvg}</p>
            {(company?.subscription?.toLowerCase() === "pro") && <p onClick={onClickFileReportHistory} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb">Filing Assistant History {questionMarkSvg}</p>}
            <p onClick={onClickViewUnallocatedFiles} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb">Unallocated Bin {questionMarkSvg}</p>
            <p onClick={checkDuplicatedFiles} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb">Deduper {questionMarkSvg}</p>
            <p onClick={onClickDeduperReportHistory} className="w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>Deduper Reports {questionMarkSvg}</p>
            <p className="w100 c14 fs13px fw400 px1rem py0-5rem cna op50 df aic jcsb">Audit Log {questionMarkSvg}</p>
            <p className="w100 c14 fs13px fw400 px1rem py0-5rem cna op50 df aic jcsb">Roll Back {questionMarkSvg}</p>
        </div>
    );

    return (
        <div className="df aic">
            {SHOW_AI_FEATURES && onDiagnose && (
                <div className="pr mr0-5rem" ref={diagnoseRef}>
                    <div className="auto-fill-icon-wrap">
                        <button
                            onClick={() => setDiagnoseOpen(o => !o)}
                            className="cp fs13px fw600 bg1 bg3-hover c3 c1-hover bw1px bo3 bss br50px px1rem py0-5rem df jcc aic"
                        >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ marginRight: '6px' }}>
                                <path d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Diagnose
                        </button>
                        <span className="auto-fill-hover-chip">Get an AI-powered quality check on your submitted answers</span>
                    </div>
                    {diagnoseOpen && (
                        <div className="pa bg1 shadow br10px zi10" style={{ minWidth: '220px', top: '110%', right: 0 }}>
                            <label className="df aic px1rem py0-5rem bg5-hover cp" style={{ gap: '0.5rem', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                <span className="checkbox w20px h20px pr">
                                    <input type="checkbox" className="bg1 bo4 bw1px bss cp td250 w20px h20px br5px" checked={diagnoseSelection.has('clarence')} onChange={() => toggleDiagnoseSelection('clarence')} />
                                </span>
                                <span className="fs13px fw400 c14">Clarence Answers</span>
                                <span className="fs11px c12 mla wsn">(AI-filled)</span>
                            </label>
                            <label className="df aic px1rem py0-5rem bg5-hover cp" style={{ gap: '0.5rem' }}>
                                <span className="checkbox w20px h20px pr">
                                    <input type="checkbox" className="bg1 bo4 bw1px bss cp td250 w20px h20px br5px" checked={diagnoseSelection.has('human')} onChange={() => toggleDiagnoseSelection('human')} />
                                </span>
                                <span className="fs13px fw400 c14">Human Answers</span>
                            </label>
                            <div className="bss bs1px bo29 mx1rem" />
                            <button
                                disabled={diagnoseSelection.size === 0}
                                onClick={() => { onDiagnose([...diagnoseSelection]); setDiagnoseOpen(false); }}
                                className="w100 bg3 c1 fw600 fs13px cp py0-75rem"
                                style={{ border: 'none', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', opacity: diagnoseSelection.size === 0 ? 0.5 : 1 }}
                            >
                                Generate Report
                            </button>
                        </div>
                    )}
                </div>
            )}
            <div className="pr menuHover ml0-5rem">
                <img src={require('../../../../../../../images/filing-assistant-hover.png')} alt="filing-assistant-hover" className="menu op0 pen pa td250" style={{ bottom: '36px', zIndex: 100 }} />
                <button className="cp fs13px fw600 bg1 bg3-hover c3 c1-hover bw1px bo3 bss br50px px1rem py0-5rem df jcc aic">
                    <img src={require('../../../../../../../images/filing-assistant-icon.png')} alt="filing-assistant-icon" className="mr0-5rem" />
                    Filing Assistant
                </button>
                {dropdown}
            </div>
        </div>
    );
}
